export default __webpack_public_path__ + "static/media/Swim_Comp_16_9.4ab0da30.png";